export const TASK_TYPE_OPTIONS = [
  { value: null, label: "All Task Types" },
  {
    label: "FS",
    options: [
      {
        value: "fs/",
        label: "All FS",
      },
      {
        value: "fs/validation",
        label: "FS Validation",
      },
      {
        value: "fs/selection",
        label: "FS Selection",
      },
      {
        value: "fs/data-alignment",
        label: "FS Data Alignment",
      },
    ],
  },
  {
    label: "BICA",
    options: [
      {
        value: "bica/",
        label: "All BICA",
      },
      {
        value: "bica/indexing",
        label: "BICA Indexing",
      },
    ],
  },
];
